import PropTypes from 'prop-types';
import React from 'react';

import LabeledControl from './LabeledControl';
import Float, { FloatProps } from './Float';

export interface LabeledFloatProps extends FloatProps {
  noborder?: boolean,
  label: string,
  labelSize?: string,
  alignRight?: boolean,
  bold?: boolean,
  underline?: boolean,
};

function LabeledFloat({
  label,
  value,
  min,
  max,
  onChange,
  alignRight,
  bold,
  underline,
  disabled,
  labelSize,
  red,
  error,
  decimals,
  floatId,
}:LabeledFloatProps) {
  return <LabeledControl
    bold={bold}
    label={label}
    labelSize={labelSize}
    underline={underline}
    alignRight={alignRight}
    control={<Float floatId={floatId} decimals={decimals} value={value} min={min} max={max} onChange={onChange} disabled={disabled} error={error} red={red} />}
  />;
}

LabeledFloat.defaultProps = {
  onChange: () => {},
  value: '',
  alignRight: false,
  bold: false,
  dark: false,
  underline: false,
  disabled: false,
  labelSize: '30%',
  red: false,
  error: false,
};

LabeledFloat.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  alignRight: PropTypes.bool.isRequired,
  bold: PropTypes.bool.isRequired,
  dark: PropTypes.bool.isRequired,
  underline: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  labelSize: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  red: PropTypes.bool.isRequired,
  decimal: PropTypes.number,
  floatId: PropTypes.string,
};


export default React.memo(LabeledFloat);
